import { EditorState } from '../types';
import { setSelectedItems } from './set-selected-items';

/**
 * Link가 활성화된 상태에서 linked track들의 ID를 가져옵니다.
 */
const getLinkedTrackIds = (
  _editorState: EditorState,
  trackId: string,
): Set<string> => new Set([trackId]);

export const lockTrack = (editorState: EditorState, trackId: string) => {
  const targetTrackIds = getLinkedTrackIds(editorState, trackId);
  let changed = false;

  const newTracks = editorState.undoableState.tracks.map((track) => {
    if (!targetTrackIds.has(track.id)) {
      return track;
    }

    if (track.locked) {
      return track;
    }

    changed = true;
    return { ...track, locked: true };
  });

  if (!changed) {
    return editorState;
  }

  return {
    ...editorState,
    undoableState: {
      ...editorState.undoableState,
      tracks: newTracks,
    },
    selectedItems: setSelectedItems(
      {
        ...editorState,
        undoableState: {
          ...editorState.undoableState,
          tracks: newTracks,
        },
      },
      editorState.selectedItems,
    ).selectedItems,
  };
};

export const unlockTrack = (editorState: EditorState, trackId: string) => {
  const targetTrackIds = getLinkedTrackIds(editorState, trackId);
  let changed = false;

  const newTracks = editorState.undoableState.tracks.map((track) => {
    if (!targetTrackIds.has(track.id)) {
      return track;
    }

    if (!track.locked) {
      return track;
    }

    changed = true;
    return { ...track, locked: false };
  });

  if (!changed) {
    return editorState;
  }

  return {
    ...editorState,
    undoableState: {
      ...editorState.undoableState,
      tracks: newTracks,
    },
  };
};
